<div class="panneau-acte-prise-en-charge">
	<di-prise-en-charge [acte]="acte" [ordonnance]="ordonnance" [onSave]="onSave" [index]="index"
		[onCancel]="onCancel" [domicileOnly]="domicileOnly"></di-prise-en-charge>
</div>